<template>
  <v-main
    :class="{
      'p-0': $route.name === 'auth-login',
      'container-main': $route.name !== 'auth-login'
    }"
  >
    <confirmation />
    <v-container
      :class="{
        'p-0': $route.name === 'auth-login'
      }"
      fluid
    >
      <breadcrumbs
        v-if="$route.name !== 'auth-login' && $route.name !== 'submenu-menu'"
      />
      <router-view />
    </v-container>
  </v-main>
</template>

<script>
import breadcrumbs from '@/components/navigation/Breadcrumbs.vue'
import confirmation from '@/components/globals/Confirmations.vue'
export default {
  components: {
    breadcrumbs,
    confirmation
  },
  mounted() {
    //
  }
}
</script>
<style lang="sass">
.container-main
  padding-left: 0 !important
  @media (width >= 960px)
    padding-top: 64px !important
    padding-left: 56px !important
</style>
